<template>

  <div class="newsswiper">
    <div class = 'hleft'></div>
    <div class="hcont">
      <div class = 'htitle'>
        <img class = 'laba' src="../../../../static/images/laba.svg" alt="">
        <span class = 'xwdt'>新闻动态:</span>
      </div>
      <div class="xwcontent" >
        <el-carousel direction="vertical" :autoplay="true"   height="44px" :interval = 'interval' indicator-position="none">
              <el-carousel-item v-for=" (item,index) in list" :key="index">
                <div @click = 'handleclickitem(item.id)'>
                {{ item.title }}
               </div>
              </el-carousel-item>
            </el-carousel>
      </div>
    </div>
    <div class="hright"></div>
  </div>


</template>

<script>

export default {
  created () {
    
  },
mounted() {
  this.getggList()
},

data () {
  return {
    interval:3000,
    list:[],
  }
},

methods: {
  getggList(){
    this.Axios({
      method:"post",
      url:Action.PROTAL_PLATF_NEWMSG,
      data:{
        isShowSub : "4"
      }
    }).then(res =>{
        if(res.data.code === '000'){
          this.list = res.data.result
        }else{
            this.$alert(res.data.msg || '系统错误...','错误提示',{
                cofirmButtonText:'确定',
                type:'error'
            })
        }
    }).catch(err =>{
            console.log(err)
    })
  },
  handleclickitem(id){
    window.open(`${rootDomain}/newsDetails?id=${id}`)
  }
},



}
</script>


<style lang="less" scoped>


.newsswiper{
 
 
  height:44px;
  display: flex;
  justify-content: space-between;
 
  .hcont{
    width:1180px;
    height:44px;
    background:#e1ebff;
    display: flex;
    .htitle{
      width:118px;
      background:url('../../../../static/images/newleft.png') no-repeat;
      display: flex;
      align-items: center;
      .laba{
        width: 22px;
	      height: 17px;
      }
      .xwdt{
        font-size:14px;
        color:#fff;
        margin-left:10px;
      }

    }
    .xwcontent{
      flex:1;
      height:44px;
      color: #222222;
      line-height:44px;
      margin-left:10px;
      cursor: pointer;
      .swiper-slide{
        width: auto!important;
      }
      .swiper-container {
          width: 100%;
          margin: 0 auto;
        }

        .swiper-wrapper {
          width: 100%;
        }
        .swiper-slide {
          width: 100%;
        }

    }
  }
  .hright{
    height:44px;
    background:#e1ebff;
    flex:1

  }
  .hleft{
    height:44px;
    background:#2c6eff;
    flex:1
  }
  
}


</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/news.vue